import { StateCreator } from 'zustand';

import {
  clearSelection,
  handleResetState,
  handleSetAllMailItems,
  handleSetDraftItems,
  handleSetInboxItems,
  handleSetLabelsItems,
  handleSetSentItems,
  handleSetSpamItems,
  handleSetTrashItems,
} from './handlers';
import { INITIAL_SELECTED_ITEMS_STATE, SelectedItemsStore } from './types';

export const createSelectedItemsSlice: StateCreator<SelectedItemsStore> = (
  set,
) => {
  return {
    ...INITIAL_SELECTED_ITEMS_STATE,
    setInboxItems: (items) => handleSetInboxItems(set, items),
    setAllMailItems: (items) => handleSetAllMailItems(set, items),
    setSentItems: (items) => handleSetSentItems(set, items),
    setDraftItems: (items) => handleSetDraftItems(set, items),
    setSpamItems: (items) => handleSetSpamItems(set, items),
    setTrashItems: (items) => handleSetTrashItems(set, items),
    setLabelsItems: (items) => handleSetLabelsItems(set, items),
    clearSelection: () => clearSelection(set),
    resetState: () => handleResetState(set),
  };
};
